// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "80cd50010cee368fa628d2a92b179b9b58cb84cb/static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"83cd5b92","98":"c3469f9b","157":"5fa962a7","215":"28b12c6b","515":"941628b2","777":"dfb468f1","952":"1030e47e"}[chunkId] + ".chunk.js";
};